var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",class:{selitem:_vm.item.id == _vm.active?true:false},on:{"click":_vm.selectitem}},[_c('span',{staticClass:"span"},[_vm._v(_vm._s(_vm.item.money))]),_vm._v("元")])}
var staticRenderFns = []

export { render, staticRenderFns }